import React from 'react';
import {Draggable, Droppable} from 'react-beautiful-dnd';

// ICONS CATEGORIAS

import CallRoundedIcon from '@mui/icons-material/CallRounded';
import Groups2RoundedIcon from '@mui/icons-material/Groups2Rounded';
import EmailRoundedIcon from '@mui/icons-material/EmailRounded';
import Diversity3RoundedIcon from '@mui/icons-material/Diversity3Rounded';
import SchoolRoundedIcon from '@mui/icons-material/SchoolRounded';
import MoreHorizRoundedIcon from '@mui/icons-material/MoreHorizRounded';
import GavelRoundedIcon from '@mui/icons-material/GavelRounded';
import WorkHistoryRoundedIcon from '@mui/icons-material/WorkHistoryRounded';
import RecordVoiceOverRoundedIcon from '@mui/icons-material/RecordVoiceOverRounded';
import PersonPinCircleRoundedIcon from '@mui/icons-material/PersonPinCircleRounded';
import HorizontalRuleOutlinedIcon from '@mui/icons-material/HorizontalRuleOutlined';
import {format} from 'date-fns';

function Tarefa({data, key, setEditarAgendamentos, onRowClick, theme}) {
    const iconsData = [
        {
            value: 'nulo',
            label: 'nulo',
            cor: '#FA2367',
            icon: HorizontalRuleOutlinedIcon,
        },
        {
            value: 'I1',
            label: 'Chamada Telefónica',
            cor: '#2AFA54',
            icon: CallRoundedIcon,
        },

        {
            value: 'C1',
            label: 'Congressos',
            cor: '#20FA96',
            icon: Groups2RoundedIcon,
        },
        {value: 'J1', label: 'E-mail', cor: '#21FAE1', icon: EmailRoundedIcon},
        {
            value: 'G1',
            label: 'Feiras',
            cor: '#FA32E9',
            icon: Diversity3RoundedIcon,
        },
        {
            value: 'E1',
            label: 'Formação',
            cor: '#1984FA',
            icon: SchoolRoundedIcon,
        },
        {
            value: 'D1',
            label: 'Outros',
            cor: '#39D0FA',
            icon: MoreHorizRoundedIcon,
        },
        {
            value: 'H1',
            label: 'Resolução litigios',
            cor: '#C02BFA',
            icon: GavelRoundedIcon,
        },
        {
            value: 'A1',
            label: 'Reunião comercial',
            cor: '#2F4EFA',
            icon: WorkHistoryRoundedIcon,
        },
        {
            value: 'F1',
            label: 'Seminário',
            cor: '#5937FA',
            icon: RecordVoiceOverRoundedIcon,
        },
        {
            value: 'B1',
            label: 'Visita cliente',
            cor: '#9128FA',
            icon: PersonPinCircleRoundedIcon,
        },
    ];

    const getItemStyle = (isDragging, draggableStyle) => ({
        userSelect: 'none',
        backgroundColor: data.color ? data.color : '#39D0FA',
        // color: ligthDarkText(),
        padding: 2,
        marginBottom: '2.5%',
        marginTop: '2.5%',
        display: 'grid',
        marginRight: 10,
        marginLeft: 10,
        borderRadius: 20,
        overflowY: 'scroll',
        // borderRadius: "10px",
        // placeItems: "center",
        ...draggableStyle,
    });

    function ligthDarkText() {
        if (theme == 'dark') {
            return '#ffff';
        } else {
            return '#000';
        }
    }

    const handleRowClick = dados => {
        setEditarAgendamentos(true);
        onRowClick(dados);
    };

    return (
        <Draggable
            key={data.id}
            draggableId={data.id}
            index={Math.floor(Math.random() * 999999)}
            // isDragDisabled={detalhe}
        >
            {(provided, snapshot) => (
                <>
                    <div
                        onClick={() => handleRowClick(data)}
                        className="card noselect"
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={getItemStyle(
                            snapshot.isDragging,
                            provided.draggableProps.style,
                        )}>
                        <div className={`flex text-[11px] font-semibold flex-row items-center`}>
                        {(() => {
                            const iconItem = iconsData.find(item => item.value === data.categoria);
                            const IconComponent = iconItem ? iconItem.icon : iconsData[0].icon;

                            return (
                                <div
                                    className={`flex justify-end bg-white rounded-full mr-2 p-1`}
                                    style={{ color: iconItem ? iconItem.cor : iconsData[0].cor }}
                                >
                                    <IconComponent key={data.id} />
                                </div>
                            );
                        })()}
                        {format(new Date(data.start), 'HH:mm')} {format(new Date(data.end), 'HH:mm')} {data.title}
                    </div>
                    </div>
                </>
            )}
        </Draggable>
    );
}

export default Tarefa;
